import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useAppDispatch } from "../redux/hooks"
import { getUserAsync } from "../redux/slices/authSlice"
import { updateApiHeaders } from "../redux/api/apiConfig"
import { ROUTES } from "../config/routes.const"

export function useSiteInitialization() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(true)
  const [isAuthenticated, setIsAuthenticated] = useState(false)

  useEffect(() => {
    const initialize = async () => {
      const token = localStorage.getItem("x-Token")
      const xCustomer = localStorage.getItem("x-Customer")

      if (token && xCustomer) {
        updateApiHeaders(token, xCustomer)

        try {
          const user = await dispatch(getUserAsync())
            .unwrap()
            .catch((err) => {
              setIsAuthenticated(false)
              setIsLoading(false)
            })

          if (user) {
            setIsAuthenticated(true)
          } else {
            setIsAuthenticated(false)
            navigate(ROUTES.LOGIN)
          }
        } catch (err) {
          setIsAuthenticated(false)
          navigate(ROUTES.LOGIN)
        } finally {
          setIsLoading(false)
        }
      } else {
        setIsLoading(false)
        setIsAuthenticated(false)
      }
    }

    initialize()
  }, [dispatch, navigate])

  return { isLoading, isAuthenticated }
}
